<template>
  <div class="about" id="about">
    <div class="left_up">
      <h1>ABOUT</h1>
    </div>
    <div class="right_down">
      <h1>ME</h1>
    </div>
    <div class="left_down">
      <p>{{ me }}</p>
    </div>
    <div class="right_up">
      <div class="icons">
        <div v-for="(ab, i) in about" :key="i">
          <b-img :src="ab.icon" @click="show(i)" :class="{
            active: i === isActive,
          }"></b-img>
        </div>
      </div>
      <div class="text">
        <h3>{{ about[abIndex].title }}</h3>
        <p>{{ about[abIndex].info }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      abIndex: 0,
      isActive: 0,
      me: 'I’m a self-taught developer passionate about creating scalable, user-friendly web applications with clean functionality and polished, modern design.',
      about: [
        {
          icon: require('../assets/about/book.svg'),
          title: 'Self-taught',
          info: "I’m a self-learner, and I believe good developers should be able to learn independently",
        },
        {
          icon: require('../assets/about/paint.svg'),
          title: 'Creative',
          info: 'I consider myself a creative person. I pay attention to detail and think outside the box.',
        },
        {
          icon: require('../assets/about/tools.svg'),
          title: 'Versatile',
          info: 'I can handle different tasks and adapt quickly to new environments.',
        },
        {
          icon: require('../assets/about/gear.svg'),
          title: 'Persevering',
          info: 'I’m persistent and determined to keep going rather than give up too quickly.',
        },
      ],
    }
  },
  methods: {
    show(index) {
      this.abIndex = index
      this.isActive = index
    },
  },
}
</script>
<style scoped lang="scss">
@import '../styles/views/About.scss'
</style>
